export const cardGray = "#f5f2f2"
export const chatGray = "#e6e6e6"
export const rentbOrange = "#FFA928"
export const orangeGradient = "linear-gradient(34deg, #ffcc33 0%, #ffcc33  7%, #f7c01b  80%, #ffb347  100%)"